export enum ButtonTheme {
  MenuFilter = `menu-filter`,
  Primary = `primary`,
  Secondary = `secondary`,
  Tertiary = `tertiary`,
  Select = `select`,
  QbSubitem = `qb-subitem`,
  QueryBuilder = `query-builder`,
  MenuFooter = `menu-footer`,
  MarketingPrimary = `marketing-primary`,
  MarketingSecondary = `marketing-secondary`,
  TemplatesEvent = `templates-event`,
}

export enum ButtonSize {
  Inline = `inline`,
  Tiny = `tiny`,
  Small = `small`,
  Medium = `medium`,
  Large = `large`,
}

export enum ButtonType {
  Base = `base`,
  Destructive = `destructive`,
  Info = `info`,
  Success = `success`,
  Warn = `warn`,
}

export enum ButtonLayout {
  Horizontal = `horizontal`,
  Vertical = `vertical`,
}
